"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function getUserInfoByEmail(email) {
    if (email === void 0) { email = ""; }
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.ADMISSIONS_BELLUS_API + "/users/emails/get/";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Authorization: "Bearer " + process.env.ADMISSIONS_BELLUS_DOCS_TOKEN,
                            "Content-Type": "application/json"
                        }
                    };
                    return [4, axios_1.default.post(url, { email: email }, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.data];
                case 3:
                    error_1 = _a.sent();
                    throw {
                        error: error_1,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getUserInfoByEmail = getUserInfoByEmail;
function getCampusesAndPrograms() {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.ADMISSIONS_BELLUS_API + "/careers/external";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Authorization: "Bearer " + process.env.ADMISSIONS_BELLUS_DOCS_TOKEN,
                            "Content-Type": "application/json"
                        }
                    };
                    return [4, axios_1.default.post(url, {}, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.data];
                case 3:
                    error_2 = _a.sent();
                    throw {
                        error: error_2,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getCampusesAndPrograms = getCampusesAndPrograms;
function getOptOuts(campus, program) {
    if (campus === void 0) { campus = ""; }
    if (program === void 0) { program = ""; }
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.ADMISSIONS_BELLUS_API + "/careers/campuses/" + campus + "/programs/" + program + "/get";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Authorization: "Bearer " + process.env.ADMISSIONS_BELLUS_DOCS_TOKEN,
                            "Content-Type": "application/json"
                        }
                    };
                    return [4, axios_1.default.post(url, {}, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.data];
                case 3:
                    error_3 = _a.sent();
                    throw {
                        error: error_3,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getOptOuts = getOptOuts;
//# sourceMappingURL=data:application/json;base64,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